import type {
  ShipNodePairingCode,
  ShipNodeStation,
  ShipNodeStationsService,
} from '@skupreme/shared/components/shipnode';
import { APIPath } from '../constants/api';
import { BaseService } from './base';

/* The EN-3274 station backend, as the portal sees it: the signed-in user's organization. */

export type {
  ShipNodePairingCode,
  ShipNodePrinter,
  ShipNodeStation,
} from '@skupreme/shared/components/shipnode';

const stationPath = (stationId: string) =>
  `${APIPath.shipnodeStations}/${encodeURIComponent(stationId)}`;

class ShipNode implements ShipNodeStationsService {
  createPairingCode = (stationName?: string) =>
    BaseService.post<ShipNodePairingCode>(
      APIPath.shipnodePairingCodes,
      stationName ? { station_name: stationName } : {},
    );

  listStations = () =>
    BaseService.get<{ stations: ShipNodeStation[] }>(APIPath.shipnodeStations);

  removeStation = (stationId: string) =>
    BaseService.remove(stationPath(stationId));

  setPrinterEnabled = (
    stationId: string,
    printerId: string,
    enabled: boolean,
  ) =>
    BaseService.put(
      `${stationPath(stationId)}/printers/${encodeURIComponent(printerId)}`,
      { enabled },
    );

  sendTestPage = (stationId: string, printerId: string) =>
    BaseService.post(`${stationPath(stationId)}/test-page`, {
      printer_id: printerId,
    });
}

const ShipNodeService = new ShipNode();
Object.freeze(ShipNodeService);
export default ShipNodeService;
